import { useAccess } from "./useAccess";

export function useHasScope(scope) {
    const access = useAccess();
    return access?.hasScope(scope);
}
